// System smoke test flag.
//
// Permanent QA reference flag. Never wired to a real funnel surface — used only
// by the /dev/ab-test validation route to verify the A/B testing system
// (assignment, exposure, enrichment, CAPI passthrough, sync idempotency).
//
// Lifecycle:
//  - Kept in the repo permanently.
//  - Inactive in the Amplitude UI by default; manually flip to Running at 100%
//    rollout when re-running the smoke validation.
//  - Pause again in UI once validation passes.

import { defineExperiment } from '../src/lib/experiments/define';

export default defineExperiment({
  key: '_system_smoke_test',
  name: 'System smoke test',
  description:
    'Validation flag for the A/B testing system. Never wire this to a real funnel surface — it exists solely for the /dev/ab-test route to verify assignment, exposure, enrichment, and CAPI passthrough end-to-end.',
  evaluationMode: 'local',
  bucketingKey: 'amplitude_id',
  bucketingUnit: 'User',
  variants: [
    { key: 'control', description: 'Control variant — renders ControlBlock.' },
    { key: 'treatment_a', description: 'Treatment variant — renders TreatmentBlock.' },
  ],
  rolloutWeights: { control: 1, treatment_a: 1 },
  mutualExclusionGroup: 'global',
  // No targetSegments — Amplitude defaults to all users, which is exactly what
  // a system smoke test wants. Real experiments set targeting here (e.g. on
  // funnel_slug) and must include a `percentage` per segment.
  // stickyBucketing is omitted — Amplitude rejects it on local-evaluation
  // experiments. (For remote-eval experiments, set it to true.)
  experimentType: 'a-b-test',
  tags: ['system', 'smoke-test'],
});
